import { post, postExFile } from "@utils/httpUtil";
// // 客服
// 分页查询会话列表
export function findCustomerServiceSessionPage(data, config) {
  return post(`/c/pc/customer/service/session/findCustomerServiceSessionPage`, data, config);
}
// 获取社区的智能医学助手配置信息
export function getIntelligentAssistantConfigByCommunityId(data, config) {
  return post(`/c/pc/intelligent/assistant/config/getIntelligentAssistantConfigByCommunityId`, data, config);
}
// 保存智能医学助手配置
export function saveIntelligentAssistantConfig(data, config) {
  return post(`/c/pc/intelligent/assistant/config/saveIntelligentAssistantConfig`, data, config);
}
// 开关社区智能医学助手
export function updateIntelligentAssistantOpenFlag(data, config) {
  return post(`/c/pc/intelligent/assistant/config/updateIntelligentAssistantOpenFlag`, data, config);
}
// 新增分发工具列表接口
export function findQaToolDistributePage(data, config) {
  return post(`/c/pc/qa/tool/distribute/findQaToolDistributePage`, data, config);
}
// 新增分发工具保存接口
export function saveOrUpdate(data, config) {
  return post(`/c/pc/qa/tool/distribute/saveOrUpdate`, data, config);
}
// 导出同步列表数据
export function exportCustomerServiceSessions(data, config) {
  return postExFile(`/c/pc/customer/service/session/exportCustomerServiceSessions`, data, config);
}
// 根据id查详情
export function findCustomerServiceSessionDetail(data, config) {
  return post(`/c/pc/customer/service/session/findCustomerServiceSessionDetail`, data, config);
}
//  常见问答管理
// 分页查询问答列表
export function findFreqAskQuestionPage(data, config) {
  return post(`/c/pc/freq/ask/question/findFreqAskQuestionPage`, data, config);
}
// 删除常见问答
export function deleteFreqAskQuestion(data, config) {
  return post(`/c/pc/freq/ask/question/deleteFreqAskQuestion`, data, config);
}
// 保存常见问答
export function saveFreqAskQuestion(data, config) {
  return post(`/c/pc/freq/ask/question/saveFreqAskQuestion`, data, config);
}
// 修改常见问答
export function updateFreqAskQuestion(data, config) {
  return post(`/c/pc/freq/ask/question/updateFreqAskQuestion`, data, config);
}
// 分页查询标签分类列表
export function findFreqAskQuestionLablePage(data, config) {
  return post(`/c/pc/freq/ask/question/findFreqAskQuestionLablePage`, data, config);
}
// 删除分类标签
export function deleteFreqAskQuestionLable(data, config) {
  return post(`/c/pc/freq/ask/question/deleteFreqAskQuestionLable`, data, config);
}
// 保存分类标签
export function saveFreqAskQuestionLable(data, config) {
  return post(`/c/pc/freq/ask/question/saveFreqAskQuestionLable`, data, config);
}
// 修改分类标签
export function updateFreqAskQuestionLable(data, config) {
  return post(`/c/pc/freq/ask/question/updateFreqAskQuestionLable`, data, config);
}
// 导出常见问答列表
export function exportFreqAskQuestions(data, config) {
  return postExFile(`/c/pc/freq/ask/question/exportFreqAskQuestions`, data, config);
}